import { application } from "../application"

import AjaxContentController from "../ajax_content_controller"
application.register("ajax-content", AjaxContentController)

import AnchorController from "../anchor_controller"
application.register("anchor", AnchorController)

import FavoriteController from "../favorite_controller"
application.register("favorite", FavoriteController)

import FluctStickyAdController from "../fluct_sticky_ad_controller"
application.register("fluct-sticky-ad", FluctStickyAdController)

import RecentlyStocksController from "../recently_stocks_controller"
application.register("recently-stocks", RecentlyStocksController)

import ScrollToTopController from "../scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SessionMonitorController from "../session_monitor_controller"
application.register("session-monitor", SessionMonitorController)

import JsLazyLoadingController from "../js_lazy_loading_controller"
application.register("js-lazy-loading", JsLazyLoadingController)

import TomSelectController from "../tom_select_controller"
application.register("tom-select", TomSelectController)
